module.exports = __webpack_public_path__ + "static/media/team-management.4b603d6b.png";